export const numberToPercentage = (portion: number, total: number) =>
  total == 0 ? 0 : (portion / total) * 100;
